import { render, staticRenderFns } from "./PlatformIcon.vue?vue&type=template&id=b5b5e208&scoped=true&"
import script from "./PlatformIcon.vue?vue&type=script&lang=js&"
export * from "./PlatformIcon.vue?vue&type=script&lang=js&"
import style0 from "./PlatformIcon.vue?vue&type=style&index=0&id=b5b5e208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b5e208",
  null
  
)

component.options.__file = "PlatformIcon.vue"
export default component.exports